import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import Dropdown from '../common/Dropdown'
import LoadingSpinner from '../common/LoadingSpinner'
import EmptyPageResults from '../common/EmptyPageResults'
import { toast } from '../common/Toast'
import { getModelsTrobleshoot } from '../../utils/requests/troubleshootingAPI'
import './troubleshooting.scss'

const Troubleshooting = (props) => {
  const { t } = useTranslation()
  const { model } = props
  const [cycles, setCycles] = useState([])
  const [selectedCycle, setSelectedCycle] = useState(null)
  const [showSpinner, setShowSpinner] = useState(null)
  const [isFirstLoad, setIsFirstLoad] = useState(true)

  useEffect(() => {
    if (model) {
      setShowSpinner(true)

      const modelsTroubleshootParams = {
        model: model,
      }

      getModelsTrobleshoot(modelsTroubleshootParams)
        .then((result) => {
          if (result.data) {
            let arr = []

            result.data.map((item) => {
              arr.push(item.faults)
            })

            const cyclesResult = [].concat(...arr)
            setCycles(cyclesResult)
          }
        })
        .catch(() => {
          toast.error(t('error.failure_msg'))
        })
        .finally(() => {
          setShowSpinner(false)
          setIsFirstLoad(false)
        })

      return
    }

    setIsFirstLoad(false)
  }, [model])

  const selectCycle = (cycleId) => {
    const cycle = cycles.find((cycle) => cycle.id === cycleId)

    if (!cycle) {
      return
    }

    setSelectedCycle(cycle)
  }

  return (
    <div className="troubleshooting-wrapper">
      {cycles.length > 0 && (
        <>
          <p className="cycle-select-title">{t('troubleshoot.select-option')}</p>
          <Dropdown
            className="dropdown-input"
            placeholder={t('troubleshoot.no-option')}
            options={cycles?.map((cycle) => ({ key: cycle.id, value: cycle.fault }))}
            initialSelectedKey={selectedCycle?.id}
            onChange={(cycle) => selectCycle(cycle.key)}
            withFiltering
          />

          {selectedCycle && (
            <div className="cycle-details-wrapper">
              <div className="cycle-title-wrapper">
                <div className="cycle-title">
                  <span>{t('fault')}</span>
                  <span className="cycle-title-number">{selectedCycle.fault}</span>
                </div>
                {selectedCycle.description?.length > 0 && (
                  <div className="cycle-category d-flex flex-column">
                    <ul className="list-none">
                      {selectedCycle.description.map((el, index) => (
                        <li key={index} className="cycle-categories">
                          <ul className="cycle-category-issue-list">
                            {el.split('\\n').map((desc, subIndex) => (
                              <li key={subIndex} className="cycle-description">
                                {desc}
                              </li>
                            ))}
                          </ul>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
              {selectedCycle.probable_cause?.length > 0 && (
                <div className="cycle-category d-flex flex-column">
                  <h3 className="cycle-category-title d-flex flex-align-center">{t('troubleshoot.probable-cause')}</h3>
                  <ul className="list-none">
                    {selectedCycle.probable_cause.map((el, index) => (
                      <li key={index} className="cycle-categories">
                        <ul className="cycle-category-issue-list">
                          {el.split('\\n').map((el, index) => (
                            <li key={index} className="cycle-category-issue">
                              {el}
                            </li>
                          ))}
                        </ul>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
              {selectedCycle.tech_troubleshooting?.length > 0 && (
                <div className="cycle-category d-flex flex-column">
                  <h3 className="cycle-category-title d-flex flex-align-center">{t('troubleshoot.tech')}</h3>
                  <ul className="list-none">
                    {selectedCycle.tech_troubleshooting.map((el, index) => (
                      <li key={index} className="cycle-categories">
                        <ul className="cycle-category-issue-list">
                          {el.split('\\n').map((el, index) => (
                            <li key={index} className="cycle-category-issue">
                              {el}
                            </li>
                          ))}
                        </ul>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
              {selectedCycle.user_troubleshooting?.length > 0 && (
                <div className="cycle-category d-flex flex-column">
                  <h3 className="cycle-category-title d-flex flex-align-center">{t('troubleshoot.user-troubleshoot')}</h3>
                  <ul className="list-none">
                    {selectedCycle.user_troubleshooting.map((el, index) => (
                      <li key={index} className="cycle-categories">
                        <ul className="cycle-category-issue-list">
                          {el.split('\\n').map((el, index) => (
                            <li key={index} className="cycle-category-issue">
                              {el}
                            </li>
                          ))}
                        </ul>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          )}
        </>
      )}
      {!isFirstLoad && cycles.length === 0 && <EmptyPageResults className="empty-list" title={t('no_data_available')} />}
      {showSpinner && (
        <div className="spinner-wrapper">
          <LoadingSpinner />
        </div>
      )}
    </div>
  )
}

export default Troubleshooting
